import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '../progress-bar';

import { NotificationService, NOTIFICATION_TYPES } from '../../services/notification-service';

import style from './notification.module.less';

export const NotificationProgressBar = ({ progress = false, progressPercentage, notificationType = 'info' }) => {
  const theme = NotificationService.getProgressBarThemeFromNotificationType(notificationType);
  const showFullProgress = !progress && progressPercentage === undefined;
  return (
    <div className={style['progress-bar-positioning-wrapper']}>
      <ProgressBar indefiniteProgress={progress} percentageComplete={showFullProgress ? 100 : progressPercentage} theme={theme} />
    </div>
  );
};

NotificationProgressBar.propTypes = {
  notificationType: PropTypes.oneOf(NOTIFICATION_TYPES),
  progress: PropTypes.bool,
  progressPercentage: PropTypes.number,
};
